
import { computed, defineComponent, reactive } from 'vue';
import draggable from 'vuedraggable';
import { Modal } from 'ant-design-vue';
import Icone from '@/core/components/UI/Icone.vue';
import Card from '@/core/components/UI/Card.vue';
import ServicoApp from '@/servicos/ServicoApp';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { IRespostaArquivo } from '@/core/models/IRespostaArquivo';
import { IInspecaoArquivo } from '@/models/Entidades/IInspecao';

export default defineComponent({
  name: 'InspecaoArquivos',
  props: {
    arquivos: {
      type: Array as () =>IInspecaoArquivo[],
      required: true,
    },
    bloquearCampos: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Card,
    Icone,
    draggable,
  },
  emits: ['update:arquivos'],
  setup(props, { emit }) {
    const servicoApp = new ServicoApp();
    const state = reactive({
      enviandoArquivos: false,
      excluindoArquivos: false,
    });

    const computedArquivos = computed({
      get: () => props.arquivos,
      set: (valor: IInspecaoArquivo[]) => {
        emit('update:arquivos', valor);
      },
    });

    async function removerArquivo(arquivo: IInspecaoArquivo) {
      state.excluindoArquivos = true;

      const indexArquivo = computedArquivos.value.findIndex((a) => a.link === arquivo.link);
      if (indexArquivo !== -1) {
        computedArquivos.value.splice(indexArquivo, 1);
      }

      state.excluindoArquivos = false;
    }

    function selecionarArquivoUpload() {
      const elemento = document.getElementById('selecionarArquivo');
      if (elemento !== null) {
        elemento.click();
      }
    }

    function isImagem(arquivo: IInspecaoArquivo): boolean {
      const nome = (arquivo.nome || arquivo.link || '').toLowerCase();
      return /\.(jpe?g|png|webp)$/i.test(nome);
    }

    function confirmaExclusao(arquivo: IInspecaoArquivo) {
      Modal.confirm({
        title: 'Você confirma a exclusão do arquivo selecionado?',
        content: '',
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: () => { removerArquivo(arquivo); },
      });
    }
    function novoArquivo(respostaArquivo: IRespostaArquivo) {
      const arquivo:IInspecaoArquivo = {} as IInspecaoArquivo;
      arquivo.codigo = 0;
      arquivo.codigoInspecao = 0;
      arquivo.link = respostaArquivo.linkArquivo;
      arquivo.data = respostaArquivo.data;
      arquivo.nome = respostaArquivo.arquivo;
      arquivo.tamanho = respostaArquivo.tamanhoApresentacao;
      arquivo.imagemRelatorio = respostaArquivo.imagemRelatorio;
      arquivo.widthRelatorio = respostaArquivo.widthRelatorio;
      arquivo.heightRelatorio = respostaArquivo.heightRelatorio;
      computedArquivos.value.push(arquivo);
    }

    async function enviarArquivos(event:any) {
      if (UtilitarioGeral.validaLista(event.target.files)) {
        state.enviandoArquivos = true;
        const listaArquivos = await servicoApp.enviarVarios(event.target.files);
        console.log('resposta upaload', listaArquivos);
        listaArquivos.forEach((arquivo) => {
          if (UtilitarioGeral.valorValido(arquivo.linkArquivo)) {
            novoArquivo(arquivo);
          }
        });
      }
      state.enviandoArquivos = false;
    }

    async function dropArquivo(event:any) {
      state.enviandoArquivos = true;
      const listaArquivos = await servicoApp.enviarVarios(event.dataTransfer.files);
      listaArquivos.forEach((arquivo) => {
        if (UtilitarioGeral.valorValido(arquivo.linkArquivo)) {
          novoArquivo(arquivo);
        }
      });
      state.enviandoArquivos = false;
    }

    return {
      props,
      computedArquivos,
      state,
      dropArquivo,
      enviarArquivos,
      confirmaExclusao,
      selecionarArquivoUpload,
      isImagem,
      UtilitarioGeral,
    };
  },
});
